module.exports = __webpack_public_path__ + "img/7.bcea4a03.png";